<script>
        import * as animateScroll from "svelte-scrollto";
        const logo = 'assets/logo.svg';

        const footerLinks = [
            {   
               name: 'Quick links',
               links: [
                   {link: 'FAQ', linkTo: '#blog'},
                   {link: 'Blog', linkTo: '#blog'},
               ]
            },
            {   
               name: 'Legal',
               links: [
                   {link: 'Terms of Use', linkTo: 'https://portal.niowm.com/legal'},
                   {link: 'Privacy', linkTo: 'https://portal.niowm.com/legal/privacy-policy'},
               ]
            },
            {   
               name: 'Get started',
               links: [
                   {link: 'What is NIO platform', linkTo: '#blog'},
                   {link: 'How to onboard on NIO?', linkTo: '#blog'},
                   {link: 'How to top-up NIO account ?', linkTo: '#blog'},
               ]
            },
            {   
               name: 'Get in touch',
               links: [
                   {link: 'support@niowm.com', linkTo: 'mailto:support@niowm.com'},
               ]
            },
        ]


        const handleRedirection = (redirectTo) => {
            if(redirectTo.substr(0,1) === '#'){
                animateScroll.scrollTo({element: redirectTo})
            }else{
                window.location.href = `${redirectTo}`;
            }
        }    



</script>

<div class="container">
    <div class="footerContainer">
        <div class="footerLogo">
            <img src={logo} alt='logo'/>
        </div>
        <div class="footerLinksContainer">

            {#each footerLinks as value }
                <div class="footerLinks">
                    <div class="footerLinksInside">
                        <div class="linkHeader">{value.name}</div>
                        {#each value.links as link }
                            <div class="footerLink" on:click={() => handleRedirection(link.linkTo)}>{link.link}</div>
                        {/each}
                    </div>
                </div>
            {/each}

        </div>
        <div class="terms">
            <div>
                © 2023 Fintech Forum Corp, s.r.o.
            </div>
            <br/>
            <div>
                NIO is a brand name of Fintech Forum Corp, s.r.o.
            </div>
            <div>
                NIO is a secure, Swiss-developed software platform, acting as a platform that connects NIO platform users to regulated third-party service providers. Please read NIO Terms of Use in their entirety before you use NIO platform.
            </div>
        </div>
       
    </div>  
</div>


<style>

    .container{
        margin-top: 100px;
        background-color: #F6F6F6;
        padding: 0 30px;
     }

     .footerContainer{
        max-width: 1170px;
        margin: 0 auto;
     }

     .footerLogo{
        height: 80px;
        display: flex;
        align-items: center;
        border-bottom: 1px solid #dddddd;   
     }

    
     .linkHeader{
        font-weight: 600;
        font-size: 20px;
        line-height: 26px;
        text-align: left;
     }

     .footerLink{
        font-size: 16px;
        line-height: 22px;
        text-align: left;
        margin: 10px 0;
        cursor: pointer;
     }
     .footerLink:hover{
        text-decoration: underline;
     }

     .footerLinks {
        display: flex;
        flex: 1;
        margin-top: 50px;
     }

     .footerLinksContainer{
        display: flex;
     }

     .terms{
        margin-top: 50px;
        color: #666666;
        font-size: 12px;
        line-height: 18px;
        text-align: left;
        height: 110px;
     }

    .terms a:link {
        color: #666666;
    }

    /* visited link */
    .terms a:visited {
        color: #666666;
    }

    /* mouse over link */
    .terms a:hover {
        color: #666666;

    }

    /* selected link */
    .terms a:active {
        color: #666666;
    }


     @media (max-width: 769px) { 

        .footerLinksContainer{
            flex-wrap: wrap;
        }

        .footerLinks {
            flex: 50%;
        }

        .footerLinks {
            margin-top: 50px;
        }

        .terms{
            height: 160px;
        }
    }

</style>